import { useGraphQLQuery } from '@opengov/bnp-core';
import { HASURA_SERVICE_URL } from '../../../../../../config/config';
import { graphql } from '../../../../../../gql-generated/hasura';
import { useToast } from '../../../../Toast/context/useToast.context';
import locale from '../../customReports-locale.json';
import { editCustomSpreadsheetModalQueryKeys } from './editCustomSpreadsheetModalQueryKeys';

const FetchSpreadsheetsForEditCustomSpreadsheetModalQuery = graphql(`
  query GetSpreadsheetsForEditCustomSpreadsheetModal($publicationId: uuid!) {
    spreadsheets(where: { publicationId: { _eq: $publicationId } }) {
      id
      name
    }
  }
`);

export function useFetchSpreadsheetsForEditMediaModal({ publicationId }: { publicationId: string }) {
  const { toggleToast } = useToast();
  return useGraphQLQuery({
    queryKey: editCustomSpreadsheetModalQueryKeys.spreadsheets(publicationId),
    variables: { publicationId: publicationId },
    document: FetchSpreadsheetsForEditCustomSpreadsheetModalQuery,
    url: HASURA_SERVICE_URL,
    options: {
      onError: (error) => {
        console.error(error);
        toggleToast({
          title: locale.errors.somethingWentWrong,
          body: locale.errors.unableToFetchCustomReports,
          severity: 'error'
        });
      }
    }
  });
}
